import isValidLink from 'util/isValidLink';

export default function sanitizeLink(url: string): string | null {
  if (url.indexOf(':') === -1) {
    url = `https://${url}`;
  }
  // The URL parser (used by isValidLink) leniently normalizes http/https URLs that are missing or
  // have a malformed authority separator (e.g. `http:www.google.com` or `http:/example.com`) and
  // ignores scheme casing, but sanitizeLink previously returned the raw string. The backend pattern
  // `(http|https)://.*` is case-sensitive and requires the `://` separator, so normalize the scheme
  // to lowercase `scheme://` here to keep frontend acceptance and backend validation in sync.
  url = url.replace(/^(https?):\/{0,2}/i, (_match, scheme) => `${scheme.toLowerCase()}://`);
  if (!isValidLink(url)) {
    return null;
  }
  return url;
}
